import type { RouteRecordRaw } from 'vue-router'

const publicRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/views/home/index.vue')
  },
  {
    path: '/404',
    component: () => import('@/views/404.vue')
  },
  {
    path: '/cad',
    component: () => import('@/views/cad/index.vue')
  },
  // {
  //   path: '/machine',
  //   component: () => import('@/views/machine/index.vue')
  // }
]

export default publicRoutes
 